/* eslint-disab//} from "./helperComponents"

const Dropdown = ({unction to detect dark mode
const detectDarkMode = () => {
    return document.documentElement.classList.contains("dark") || 
           (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches)
}x-a11y/no-autofocus */

import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import Select from "react-select"

import { ClearIndicatorComponent,
    CustomValueContainerComponent,
    DropdownIndicatorComponent,
    InputComponent,
    MultiValueComponent,
    OptionsComponent
} from "./helperComponents"

const Dropdown = ({
    placeholder,
    defaultValue,
    options = [],
    changeHandler,
    className,
    name,
    errorData,
    isMulti,
    disabled,
    menuPlacement, // use for placement of menu of dropdown top bottom etc
    index,
    renderKey,
    dataTestId,
    isRequired = true, // // DON"T MODIFY THIS FLAG, PASS BOOLEAN VALUE FROM COMPONENT LABEL
    isMultiWithCheckbox = false, // DON"T MODIFY THIS FLAG, PASS BOOLEAN VALUE FROM COMPONENT LABEL
    selectedItemLength,
    isValueSelect = false, // DON"T MODIFY THIS FLAG, PASS BOOLEAN VALUE FROM COMPONENT LABEL
    hideOptionsOnChange = false,
    optionsWithHide = [],
    hasSelectBoXChanged,//  THIS CONDITION USED FOR RESET THE DROPDOWN VALUE AFTER SELECTED THE DEPENDEND DROPDOWN
    labelIsRequired = true, //  DON"T MODIFY THIS FLAG, PASS BOOLEAN VALUE FROM COMPONENT LABEL
    isUnselectEnabled = false,
    isCustomErrorMessage = false,
    isMultiValueSelect = false,
    AllSelectLabel,
    isAllOption,
    errorcustomName,
    isSmallInputBox = false,
    optionsLoading = false
}) => {
    // Helper function to detect dark mode - only check app's dark mode class
    const detectDarkMode = () => {
        return document.documentElement.classList.contains("dark")
    }

    const isValid = !(errorData && name && errorData[name])
    const { t } = useTranslation()
    const [focused, setFocused] = useState(false)
    const [darkMode, setDarkMode] = useState(detectDarkMode())

    const initialOptions = useRef(options)
    const [renderOptions, setRenderOptions] = useState(initialOptions?.current)

    const refSelect = useRef(null)
    const allOption = { label: AllSelectLabel, value: "*" }
    const isAllSelected = useRef(false)

    useEffect(() => {
        if (hasSelectBoXChanged) {
            setFocused(false)
        }
    }, [hasSelectBoXChanged])

    useEffect(() => {
        if (options && options.length > 0 && isMulti) {
            const stateOptions =
                options?.filter((option) => {
                    if (initialOptions.current !== undefined) {
                        return !initialOptions?.current.find((newOpt) => {
                            return newOpt === option
                        })
                    }
                }) ?? []
            initialOptions.current = stateOptions
        }
    }, [options])

    useEffect(() => {
        if (refSelect?.current) {
            if (focused) {
                refSelect?.current?.focus()
            } else {
                refSelect?.current?.blur()
            }
        }
    }, [focused])

    useEffect(() => {
        if (defaultValue instanceof Array && defaultValue?.length > 0 && isMulti) {
            const stateOptions =
                initialOptions.current?.filter((option) => {

                    return !defaultValue.find((newOpt) => {
                        return newOpt === option
                    })
                }) ?? []
            const updatedOptions = defaultValue?.concat(stateOptions)
            let uniqueMap = new Map()

            if (updatedOptions?.length > 0) {
                updatedOptions.forEach(item => {
                    let key = `${item?.label}-${item?.value}`
                    if (!uniqueMap.has(key)) {
                        uniqueMap.set(key, item)
                    }
                })
            }


            const finalOptions = Array.from(uniqueMap.values())
            setRenderOptions(finalOptions)
        }
    }, [options])

    // Monitor dark mode changes
    useEffect(() => {
        const handleDarkModeChange = () => {
            setDarkMode(detectDarkMode())
        }

        // Listen for dark mode toggle via class change on document element
        const observer = new MutationObserver(handleDarkModeChange)
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["class"]
        })

        return () => {
            observer.disconnect()
        }
    }, [])

    const CustomValueContainer = ({ children, ...props }) => {
        return CustomValueContainerComponent({ children,isRequired,labelIsRequired, ...props })
    }

    function onSelectChange(newOptions) {
        const stateOptions =
            initialOptions.current?.filter((option) => {

                return !newOptions.find((newOpt) => {
                    return newOpt === option
                })
            }) ?? []
        const updatedOptions = newOptions?.concat(stateOptions)

        let uniqueMap = new Map()

        updatedOptions.forEach(item => {
            let key = `${item?.label}-${item?.value}`
            if (!uniqueMap.has(key)) {
                uniqueMap.set(key, item)
            }
        })
    }

    const DropdownIndicator = (props) => {
        return DropdownIndicatorComponent(props)
    }

    const ClearIndicator = (props) => {
        return ClearIndicatorComponent(props)
    }
    
    const Input = (props) => {
        return InputComponent(props)
    }

    const Option = (props) => {
        return OptionsComponent(props, isAllOption,isSmallInputBox)
        
    }

    const MultiValue = ({ index, getValue, isDisabled, ...props }) => {
        return MultiValueComponent({ index, getValue, isDisabled,selectedItemLength, ...props })
    }

    const MultiValueTop = (length, isDisabled) => {
        const maxToShow = selectedItemLength || 3
        const multiTop = "inherit"
        const top = "-36%"

        if (length <= maxToShow) {
            return top
        }
        else {
            if (isDisabled)
                return multiTop
            return top
        }
    }

    const getTopValue = (state) => {
        if(state.hasValue || state.selectProps.inputValue || state.selectProps.isFocused) {
            if(!state.isMulti) {
                return "-36%"
            } else {
                return MultiValueTop(state?.selectProps?.value?.length, state.isDisabled)
            }
        } else {
            return "15%"
        }
    }

    const customeStyles = {
        control: (base, state) => ({
            ...base,
            backgroundColor: state.isDisabled
                ? (darkMode ? "#4a5568" : "#F8F9FA")
                : (() => {
                    if (darkMode) {
                        const backgroundColor = state.selectProps.menuIsOpen ? "#2d3748" : "#2d3748"
                        return backgroundColor
                    }
                    const backgroundColor = state.selectProps.menuIsOpen ? "#EDF5FF" : "#FFFFFF"
                    return backgroundColor
                })(),
            borderColor: state.selectProps.menuIsOpen
                ? (darkMode ? "#60a5fa" : "#003DA5")
                : (() => {
                    if (darkMode) {
                        const borderColor = isValid ? "#4a5568" : "#CE121F"
                        return borderColor
                    }
                    const borderColor = isValid ? "#CED0D6" : "#CE121F"
                    return borderColor
                })(),
            borderRadius: 8,
            boxShadow: null,
            fontSize: 14,
            fontfamily: "Avenir",
            height: (state.isMulti && !state.isDisabled) && 38,
            color: darkMode ? "#979797" : "#000000",
            "&:hover": {
                borderColor: darkMode ? "#60a5fa" : "#003DA5"
            }
        }),
        menu: (styles) => ({
            ...styles,
            backgroundColor: darkMode ? "#1a202c" : "#ffffff",
            border: darkMode ? "1px solid #4a5568" : "1px solid #CED0D6",
            borderRadius: 8,
            boxShadow: darkMode ? "0 4px 11px rgba(0, 0, 0, 0.3)" : "0 4px 11px rgba(0, 0, 0, 0.1)"
        }),
        menuList: (styles) => ({
            ...styles,
            backgroundColor: darkMode ? "#1a202c" : "#ffffff"
        }),
        indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
        input: (styles) => ({
            ...styles,
            fontSize: "19px",
            lineHeight: "20px",
            padding: "5px 0 5px 0",
            color: darkMode ? "#ffffff" : "#000000"
        }),
        multiValue: (styles) => ({
            ...styles,
            backgroundColor: darkMode ? "#4a5568" : "#F3F3F3",
            borderColor: darkMode ? "#2d3748" : "#CED0D6",
            borderRadius: 10,
            maxWidth: 100
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            color: darkMode ? "#ffffff" : "#3438F"
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: darkMode ? "#a0aec0" : "#002466",
            ":hover": {
                backgroundColor: "transparent",
                color: darkMode ? "#ffffff" : "#002466"
            }
        }),
        option: (styles, state) => ({
            ...styles,
            backgroundColor: (() => {
                if (darkMode) {
                    if (state.isSelected) return "#4a5568"
                    if (state.isFocused) return "#2d3748"
                    return "#1a202c"
                }
                if (state.isSelected) return "#E3ECF9"
                if (state.isFocused) return "#F8F9FA"
                return "#fff"
            })(),
            borderBottom: isMultiWithCheckbox 
                ? (darkMode ? "1px solid #4a5568" : "1px solid #CED0D6") 
                : "none",
            color: darkMode ? "#ffffff" : "#000",
            fontSize: 14,
            padding: 8,
            "&:hover": {
                backgroundColor: (() => {
                    if (darkMode) {
                        return state.isSelected ? "#4a5568" : "#2d3748"
                    }
                    return state.isSelected ? "#E3ECF9" : "#F8F9FA"
                })()
            },
            "&:last-child": {
                borderBottom: "none"
            }
        }),
        placeholder: (styles, state) => ({
            ...styles,
            bottom: (state.isMulti && state.isDisabled) ? "100%" : "inherit",
            color: (() => {
                if (darkMode) {
                    return state.isFocused ? "#979797" : "#a0aec0"
                }
                return state.isFocused ? "#34383f" : "#6C6C6C"
            })(),
            display: (state.isMulti && state.isDisabled) ? "flex" : "inherit",
            fontSize:
                state.hasValue ||
                state.selectProps.inputValue ||
                state.selectProps.isFocused
                    ? 10
                    : 14,
            marginTop: (state.selectProps.isFocused || state.hasValue) ? 9 : 10,
            padding: "2px",
            position: "absolute",
            textWrap: "nowrap",
            top: getTopValue(state),
            transition: "top 0.2s"
        }),
        singleValue: (styles, state) => ({
            ...styles,
            color: (() => {
                if (darkMode) {
                    return state.isDisabled ? "#a0aec0" : "#ffffff"
                }
                return state.isDisabled ? "#34383f" : "#000000"
            })()
        }),
        valueContainer: (base) => ({
            ...base,
            overflow: "visible",
            paddingLeft: 10,
            paddingTop: 0
        })
    }

    const getSingleValue = (arr, val) => {
        if (arr?.length && arr?.find(({ value }) => value === val)) {
            return arr?.length ? arr.find(({ value }) => value === val) : arr
        } else {
            return null
        }
    }

    const getValue = (value, arr, isMulti) => {
        let val = value
        if (val !== undefined) {
            if (!isMulti) {
                return getSingleValue(arr, val)
            } else {
                return isMultiSelectHelper(val, arr)
            }
        } else {
            return isMulti ? [] : null
        }
    }

    const isMultiSelectHelper = (val, arr) => {
        if (!Array.isArray(val)) {
            let existingValues = val?.split(",")
            existingValues = existingValues?.map(function (el) {
                return el?.trim().toLowerCase()
            })
            return arr?.filter((x) => {
                return existingValues?.includes(x?.label?.toString()?.trim().toLowerCase())
                    || existingValues?.includes(x?.value?.toString()?.trim().toLowerCase())
            })
        } else {
            if (isMultiValueSelect) {
                let existingValues = val?.map(function (el) {
                    if (typeof el === "string") {
                        return el?.trim().toLowerCase()
                    } else {
                        return el
                    }
                })
                return arr?.filter((x) => {
                    if (x?.value && typeof x?.value === "string") {
                        return existingValues?.includes(x?.value?.trim().toLowerCase())
                    } else {
                        return existingValues?.includes(x?.value)
                    }
                })
            }
            return val
        }
    }

    const renderComponent = () => {
        if (isMultiWithCheckbox) {
            return {
                ClearIndicator,
                DropdownIndicator,
                Input,
                MultiValue,
                Option,
                ValueContainer: CustomValueContainer
            }
        } else {
            return {
                DropdownIndicator,
                Input,
                ValueContainer: CustomValueContainer
            }
        }
    }

    const checkOptions = (defaultValue, option) => {
        return !defaultValue.find((newOpt) => newOpt === option)
    }

    const onDropDownBlur = () => {

        setTimeout(() => {
            if (defaultValue instanceof Array && defaultValue?.length > 0 && isMulti) {
                const stateOptions =
                    initialOptions.current?.filter((option) => {
                        return checkOptions(defaultValue, option)
                    }) ?? []
                const updatedDefaultValue = isMultiValueSelect ? 
                    stateOptions?.filter(item => defaultValue.includes(item?.value)) : 
                    defaultValue
                const updatedOptions = updatedDefaultValue?.concat(stateOptions)
                let uniqueMap = new Map()
                updatedOptions?.forEach(item => {
                    let key = `${item?.label}-${item?.value}`
                    if (!uniqueMap.has(key)) {
                        uniqueMap.set(key, item)
                    }
                })
                const finalOptions = Array.from(uniqueMap.values())
                setRenderOptions(finalOptions)
            }
        }, 500)
    }

    const getOptions = () => {
        let updatedOptions = []
        if(isAllOption) {
            if(renderOptions?.length > 0) {
                updatedOptions = [allOption, ...renderOptions]
            } else if(options?.length > 0) {
                updatedOptions = [allOption, ...options]
            } else {
                updatedOptions = []
            }
        } else {
            updatedOptions = options
        }
        return updatedOptions
    }

    const isHideOptionsOnChange = () => {
        if (hideOptionsOnChange) {
            return optionsWithHide
        } else {
            return options
        }
    }

    const getCustomErrorMsg = () => {
        let errorMsg
        if(errorcustomName) {
            errorMsg = t(`errorMessage.${errorcustomName}.${name}`)
        } else if(isCustomErrorMessage) {
            errorMsg = errorData[name]
        } else {
            errorMsg = t(`errorMessage.${name}`)
        }
        return errorMsg
    }

    return (
        <>
            <Select
                id={ name }
                ref={ refSelect }
                className={ className }
                key={ renderKey }
                classNamePrefix="select"
                components={ { ...renderComponent() } }
                styles={ customeStyles }
                placeholder={ placeholder }
                options={ getOptions() }
                { ...(isValueSelect
                    ? { value: !hasSelectBoXChanged ? getValue(defaultValue, isHideOptionsOnChange(), isMulti) : "" }
                    : { defaultValue: getValue(defaultValue, hideOptionsOnChange 
                        ? optionsWithHide : options, isMulti) }) }
                getOptionValue={ (opt) => opt.label }
                getOptionLabel={ (opt) => `${opt.label}` }
                name={ name }
                isMulti={ isMulti }
                isClearable={ isUnselectEnabled }
                onFocus={ () => {
                    setFocused(true)
                }
                }
                openMenuOnClick={ true }
                onBlur={ () => {
                    setFocused(false)
                    onDropDownBlur()
                } }
                closeMenuOnSelect={ !(isMulti && isMultiWithCheckbox) }
                hideSelectedOptions={ false } // Hide Selected Option
                isFocused={ focused }
                isDisabled={ disabled || false }
                onChange={ (selectedValue) => {
                    if (
                        isMulti &&
                        selectedValue.length &&
                        selectedValue.find((option) => option.value === "*")
                    ) {
                        if (isAllSelected.current === true) {
                            changeHandler([], name, index)
                            onSelectChange([])
                            isAllSelected.current = false
                        } else {
                            changeHandler(options, name, index)
                            onSelectChange(options)
                            isAllSelected.current = true
                        }
                    } else if (isMulti) {
                        if (selectedValue.length > 0) {
                            changeHandler(selectedValue, name, index)
                            onSelectChange(selectedValue)
                            isAllSelected.current = selectedValue.length === options.length
                        } else {
                            changeHandler([], name)
                            onSelectChange([])
                            isAllSelected.current = false
                        }
                    } else {
                        changeHandler(selectedValue, name, index)
                    }
                } }
                data-testid={ dataTestId || "react-select" }
                menuPlacement={ menuPlacement }
                isSearchable={ true }
                aria-labelledby={ name }
                isLoading={ optionsLoading }
            />
            { errorData && name && errorData[name] && (
                <span className="text-red dark:text-red-400 text-xs font-normal font-['Avenir'] leading-[14px] pt-1">
                    { getCustomErrorMsg() }
                </span>
            ) }
        </>
    )
}

Dropdown.propTypes = {
    AllSelectLabel: PropTypes.string,
    changeHandler: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string,
    dataTestId: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    disabled: PropTypes.bool,
    errorData: PropTypes.object,
    errorcustomName: PropTypes.string,
    hasSelectBoXChanged: PropTypes.bool,
    hasValue: PropTypes.bool,
    hideOptionsOnChange: PropTypes.bool,
    index: PropTypes.number,
    isAllOption: PropTypes.bool,
    isCustomErrorMessage: PropTypes.bool,
    isFocused: PropTypes.bool,
    isMulti: PropTypes.bool,
    isMultiValueSelect: PropTypes.bool,
    isMultiWithCheckbox: PropTypes.bool,
    isRequired: PropTypes.bool,
    isSelected: PropTypes.bool,
    isSmallInputBox: PropTypes.bool,
    optionsLoading: PropTypes.bool,
    isUnselectEnabled: PropTypes.bool,
    isValueSelect: PropTypes.bool,
    label: PropTypes.string,
    labelIsRequired: PropTypes.bool,
    menuPlacement: PropTypes.string,
    name: PropTypes.string,
    options: PropTypes.array.isRequired,
    optionsWithHide: PropTypes.array,
    placeholder: PropTypes.string,
    renderKey: PropTypes.string,
    selectProps: PropTypes.object,
    selectedItemLength: PropTypes.number,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
}

export default React.memo(Dropdown)
